import korea from "vee-validate/dist/locale/ko.json";

class Constant {
  validate = {
    language: {
      korea: korea,
    },
  };
  map = {
    kakaoRestApiKey: "4d2469516db02caafb9655b3dd1f6e88",
  };
}

export default new Constant();
